var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", { attrs: { actions: _vm.actions, page: _vm.page } }),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } }),
      _vm._l(_vm.appointments, function(appointment, idx) {
        return _c(
          "div",
          {
            key: appointment.appointmentId,
            staticClass: "container-fluid p-3 bg-secondary-11 mt-4"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm d-flex" }, [
                _vm._m(0, true),
                _c("div", [
                  _c("span", { staticClass: "data-name" }, [
                    _vm._v("Número de Cita:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(appointment.appointmentId))
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [_vm._v("Fecha:")]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(appointment.appointmentDate))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [_vm._v("Horario:")]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(appointment.appointmentTime))
                ])
              ]),
              appointment.specialistsAvailable.length === 0
                ? _c("div", { staticClass: "col-sm" }, [
                    _c("span", { staticClass: "color-secondary-2 font-14" }, [
                      _vm._v(
                        " " +
                          _vm._s(appointment.specialistsNotAvailableMessage) +
                          " "
                      )
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "col-md-3 col-sm-12" },
                    [
                      _c(
                        "validation-observer",
                        { ref: "specChangeValidator" + idx, refInFor: true },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        staticClass: "w-100",
                                        attrs: {
                                          "custom-error-msg":
                                            "Favor de seleccionar un especialista.",
                                          error: errors[0],
                                          fieldkey: "specialistId",
                                          fieldname: "fullName",
                                          options:
                                            appointment.specialistsAvailable,
                                          placeholder: "Seleccione Especialista"
                                        },
                                        model: {
                                          value:
                                            _vm.appointments[idx]
                                              .selectedSpecialist,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.appointments[idx],
                                              "selectedSpecialist",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "appointments[idx].selectedSpecialist"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
              appointment.specialistsAvailable.length > 0
                ? _c(
                    "div",
                    { staticClass: "col-sm h-100 d-flex justify-content-end" },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-exchange-alt",
                          text: "Cambiar",
                          variant: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.changeSpecialist(
                              idx,
                              _vm.appointments[idx]
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("hr"),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-2" }, [
                _c("div", { staticClass: "ml-4" }, [
                  _c("span", { staticClass: "data-name" }, [
                    _vm._v("Tipo de Servicio:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(appointment.serviceName))
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-sm-4" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Disciplina:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(appointment.disciplineName))
                ])
              ]),
              _c("div", { staticClass: "col-sm-2" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Localización:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(appointment.locationName))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Estudiante:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(appointment.studentDescription))
                ])
              ])
            ])
          ]
        )
      }),
      _vm._l(_vm.tapRequests, function(item, idx) {
        return _c(
          "div",
          { key: idx, staticClass: "container-fluid p-3 bg-secondary-11 mt-4" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Número de Consulta:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.tapNumber))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Fecha de Comienzo:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm._f("date")(item.startDate)))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [_vm._v("Maestro:")]),
                _c("p", { staticClass: "data" }, [_vm._v(_vm._s(item.teacher))])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Asistente:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.specialist))
                ])
              ])
            ])
          ]
        )
      }),
      _vm._l(_vm.referrals, function(item, idx) {
        return _c(
          "div",
          { key: idx, staticClass: "container-fluid p-3 bg-secondary-11 mt-4" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Número de Referido:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.referralNumber))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Fecha de Inicio de Servicio:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm._f("date")(item.startDate)))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Especialista de Admisión:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.admissionSpecialist))
                ])
              ]),
              _c("div", { staticClass: "col-sm" }, [
                _c("span", { staticClass: "data-name" }, [
                  _vm._v("Especialista de Servicio:")
                ]),
                _c("p", { staticClass: "data" }, [
                  _vm._v(_vm._s(item.serviceSpecialist))
                ])
              ])
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2" }, [
      _c("em", {
        staticClass:
          "fas fa-calendar-alt color-primary-2 mt-2 rounded-circle shadow bg-white p-2"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }